import classNames from 'classnames';
import React from 'react';

import { ObjectZoneType } from 'entities/common';
import { ZoneCard } from './ZoneCard';

type Props = {
  zones: ObjectZoneType[];
};

export const ZoneCardsGrid: React.FC<Props> = ({ zones }) => {
  return (
    <div className={classNames('dashboard-zones')}>
      {(zones || [])?.map((zone) => (
        <ZoneCard key={zone.id} zone={zone} />
      ))}
    </div>
  );
};
